import {nameList} from '@/api/common'

const app = {

	state: {
		bookList: [],
	},
	getters: {},
	mutations: {
		SET_BOOKLIST: (state, lists) => {
			state.bookList = lists;
		},
	},

	actions: {
		getBookListAcions({commit}) {
			return new Promise((resolve, reject) => {
				nameList().then(response => {
					const data = response.data;
					if (data.items) {
						commit('SET_BOOKLIST', data.items);
					}
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
	}
}
export default app



// WEBPACK FOOTER //
// ./src/store/books.js